import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-minus",
  templateUrl: "./med-icon-minus.component.html",
})
export class MedIconMinusComponent extends SvgMixinComponent {}
